import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { URLSearchParams } from '@angular/http';

import { AuthHttpClient } from '../../../providers/auth-http.service';
import { AuthService } from '../../../providers/auth.service';

import { SharedNotificationService } from '../shared/services/shared-notification.service';

import { SharedJobService } from '../shared/services/shared-job.service';
import { IApp } from '../../../app';


export class NotificationsComponent implements IApp, OnInit {
	public client: any;
	public jobs: any[] = [];
	public activeJobs: any[] = [];
	public pausedJobs: any[] = [];
	public notificationsPreferences: any[] = [];
	public notificationsTypes = {
		candidate_profile: 'New Profiles',
		interview: 'Interview Updates'
	};
	public loading = true;
	public done = false;

	constructor(
		private titleService: Title,
		private authHttp: AuthHttpClient,
		private authService: AuthService,
		private sharedNotificationService: SharedNotificationService,
		private sharedJobService: SharedJobService) {
			this.setAppTitle();
	}

	// Lifecycle Events
	public ngOnInit(): void {
		this.getRequiredData();
	}

	public setAppTitle(): void  {
		this.titleService.setTitle('hackajob.co - Notifications');
	}

	public onNotificationsPreferencesSubmit(): void {
		let data: any[] = [];

		Object.keys(this.notificationsPreferences).forEach((key) => {
			Object.keys(this.notificationsPreferences[key]).forEach((preferences) => {
				data.push({
					notification_name: this.notificationsPreferences[key][preferences].notification_name,
					entity_id: this.notificationsPreferences[key][preferences].entity_id,
					entity_type: this.notificationsPreferences[key][preferences].entity_type,
					is_enabled: this.notificationsPreferences[key][preferences].is_enabled,
					enabled_option: this.notificationsPreferences[key][preferences].enabled_option
				});
			});
		});

		this.sharedNotificationService.updateNotificationsPreferences(this.authService.userId, data).subscribe(
			(resp) => {
				this.done = true;
				setTimeout(() => {
					this.done = false;
				}, 2000);
			}
		);
	}

	public onRadioPreferenceChange(jobId: string, notificationName: string, value: boolean, enabledOption = null): void {
		this.notificationsPreferences[jobId][notificationName].is_enabled = value;
		this.notificationsPreferences[jobId][notificationName].enabled_option = enabledOption;
	}

	// Service calls
	private getRequiredData() {
		this.loading = true;

		let params: URLSearchParams = new URLSearchParams();
		params.set('status', 'all');

		this.sharedJobService.getClientJobs(this.authService.userId, params)
			.flatMap((jobs) => {
				this.jobs = jobs;

				this.activeJobs = this.jobs.filter((job) => job.is_approved);
				this.pausedJobs = this.jobs.filter((job) => !job.is_approved);

				return this.sharedNotificationService.getNotificationsPreferences(this.authService.userId);
			})
			.subscribe(
				(notificationsPreferences: any) => {
					this.notificationsPreferences = notificationsPreferences;

					this.loading = false;
				}
			);
	}
static ctorParameters() { return [ { type: Title }, { type: AuthHttpClient }, { type: AuthService }, { type: SharedNotificationService }, { type: SharedJobService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/notifications/notifications.component.ts